import { render, staticRenderFns } from "./AddToOrderStandard.vue?vue&type=template&id=615b65ce"
import script from "./AddToOrderStandard.vue?vue&type=script&lang=js"
export * from "./AddToOrderStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports